<template>
  <div class="side-class">
    <div class="side-class-title">
      <div class="side-class-btn" v-if="reltype === 'text'">相关阅读</div>
      <div class="side-class-btn" v-if="reltype === 'video'">相关视频</div>
    </div>
    <div class="hot-container">
      <div
        class="side-single-hot"
        v-for="(hot,index) in articleList"
        :key="index"
        @click="toDetail(hot)"
        v-if="index < 3"
      >
        <div class="hot-content">{{ hot.title }}</div>
        <div class="hot-icon">
          <span>
            <i class="el-icon-view"></i>
            {{hot.views}}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      articleList: [],
      reltype: '' // 相关阅读类型
    };
  },
  created() {
    this.getRelevant();
  },
  methods: {
    getRelevant() {
      this.httpGet(this.$root.getRelevant, {
        id: this.$route.query.id
      })
        .then(result => {
          this.articleList.push(...result.res);
          this.reltype = result.type;
        })
        .catch(err => {
          console.error('getRelevant-err', err);
        });
    },
    toDetail(item) {
      if (item.id !== '') {
        // 面包屑
        let breadObj = {
          id: item.id,
          path: 'article-list?id=' + item.id,
          name: item.title
        };
        this.$store.commit('setBreadArr', breadObj);
        this.$router.push({
          name: 'article-details',
          query: {
            id: item.id
          }
        });
      }
    }
  },
  watch: {
    '$route.query.id': function(newValue, oldValue) {
      console.log('newValue, oldValue', newValue, oldValue);
      if (this.$route.name == 'article-details') {
        this.articleList = [];
        this.getRelevant();
      }
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.side-class {
  padding: 0 24px 12px 24px;
}

.hot-container {
}

.side-single-hot {
  margin 10px 0
  flex-y(flex-start, flex-start);

  .hot-content {
    width: 100%;
    font-size: 14px;
    color: gray6;
    line-height: 17px;
    max-width 232px
    multi(2);
  }

  .hot-content:hover {
    color: #4093FF;
  }

  .hot-icon {
    margin-top: 5px;
    height: 17px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 17px;

    i {
      font-size: 12px;
      color: #9DA4B3;
    }
  }
}

.side-single-hot:hover {
  cursor: pointer;
  // color: blue;
  // color: #4093FF;
}

.more {
  more();
}

.more:hover {
  cursor: pointer;
}
</style>
